"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDialogHeader = void 0;
var _DialogHeader = require("./DialogHeader");
// TODO: in v9, move styled() from DialogHeader.jsx to here
var StyledDialogHeader = _DialogHeader.DialogHeader;
exports.StyledDialogHeader = StyledDialogHeader;